var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{ref:"dots",staticClass:"sd-carousel__dots"},_vm._l((_vm.slideCount),function(slide){return _c('li',{key:slide},[_c('button',{class:{
        'sd-carousel__dot': slide - 1 !== _vm.activeSlide,
        'sd-carousel__dot--current': slide - 1 === _vm.activeSlide
      },attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('active-slide', slide - 1)}}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }